/**
 * 은행 계좌 아코디언 컨트롤러.
 *
 * [data-fw-bank-toggle] 클릭 시 가장 가까운 [data-fw-bank-group] (또는 `.bank-group`) 에
 * `.open` 클래스 토글. CSS 에서 `.bank-group.open .bank-list { max-height: ... }` 식으로 전환 구현.
 */
export const BANK_ACCORDION_CONTROLLER_SCRIPT = `
<script data-fw-bank-accordion-controller>
(function () {
  function init() {
    var toggles = document.querySelectorAll('[data-fw-bank-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var btn = toggles[i];
      if (btn.dataset.fwBankInit) continue;
      btn.dataset.fwBankInit = '1';
      btn.addEventListener('click', (function (b) {
        return function () {
          var group = b.closest('[data-fw-bank-group]') || b.closest('.bank-group');
          if (group) group.classList.toggle('open');
        };
      })(btn));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=bank-accordion.js.map